import { AsyncState } from '@hglobal/common';

import { ApplyBalanceSkinRes, GetBalanceRes, GetCategoriesRes, GetTeamBalanceRes } from '../models';

export const balanceFeatureKey = 'Balance';

export interface BalanceState {
  balance: GetBalanceRes;
  teamBalance: GetTeamBalanceRes['teamBalance'];
  categories: GetCategoriesRes;
  getBalanceAction: AsyncState<GetBalanceRes>;
  getTeamBalanceAction: AsyncState<GetTeamBalanceRes>;
  getBalanceSkinsAction: AsyncState<GetBalanceRes>;
  applyBalanceSkinAction: AsyncState<ApplyBalanceSkinRes>;
  getCategoriesAction: AsyncState<GetCategoriesRes>;
}
